import React from 'react';
import st from './style.module.scss';
import arrow from '../../../../assets/images/landing/arrow-working-process.svg';
import { getWorkingProcessData } from './constants';
import { useTranslation } from 'react-i18next';

const WorkingProcess = ({ type }) => {
  const { t } = useTranslation();
  const WORKING_PROCESS_DATA = getWorkingProcessData(t);
  const data = WORKING_PROCESS_DATA[type];
  return (
    <div className={`row mt-3 ${st.cardContainerMobile}`}>
      <div className={`col-lg-3 col-sm-6 ${st.cardContainer}`}>
        <Arrow style="hasArrowTop" />
        <ContentCard step={data.account} />
      </div>
      <div className={`col-lg-3 col-sm-6 ${st.cardContainer}`}>
        <Arrow style="hasArrowBottom" />
        <ContentCard step={data.resume} />
      </div>
      <div className={`col-lg-3 col-sm-6 ${st.cardContainer}`}>
        <Arrow style="hasArrowTop" />
        <ContentCard step={data.find} />
      </div>
      <div className={`col-lg-3 col-sm-6 ${st.cardContainer}`}>
        <ContentCard step={data.add} />
      </div>
    </div>
  );
};

export default WorkingProcess;

const Arrow = ({ style }) => {
  return (
    <div className={st[style]}>
      <img src={arrow} alt="arrow" />
    </div>
  );
};

const ContentCard = ({ step }) => {
  return (
    <div className={st.cardContent}>
      <div className={st.cardIcon}>
        <div>{step.icon}</div>
      </div>
      <h4 className={st.cardTitle}>{step.title}</h4>
      <p className={st.cardDescription}>{step.description}</p>
    </div>
  );
};
